import { SHOW_MODAL } from '../../actions/show-modal';
import { HIDE_MODAL } from '../../actions/hide-modal';
import { WIX_MODAL_CLOSED } from '../../actions/load-and-persist-wix-modal';

const initialState = [];
export default function modalIdList(state = initialState, action) {
  switch (action.type) {
    case SHOW_MODAL: {
      const { type } = action.payload;
      if (state.indexOf(type) > -1) {
        return state;
      }

      return [...state, action.payload.type];
    }
    case HIDE_MODAL: {
      const index = state.indexOf(action.payload.type);
      if (index === -1) {
        return state;
      }

      return [...state.slice(0, index), ...state.slice(index + 1)];
    }
    case WIX_MODAL_CLOSED:
      return initialState;
    default:
      return state;
  }
}
